import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Extract a user-facing error message from an unknown caught error.
 * Handles plain Errors, GraphQL ClientErrors, and arbitrary values.
 */
export function getErrorMessage(error: unknown, fallback = "An error occurred"): string {
  if (error instanceof Error) {
    // GraphQL ClientError from graphql-request
    const gqlError = error as Error & {
      response?: { errors?: Array<{ message?: string }> };
    };
    const gqlMessage = gqlError.response?.errors?.[0]?.message;
    if (gqlMessage) return gqlMessage;

    return error.message || fallback;
  }
  if (typeof error === "string") return error;
  return fallback;
}
